import styled, { css } from 'styled-components';
import { getAppearance, getSize } from './helpers';
/* Button Container */

export var Container = styled.button.withConfig({
  displayName: "elements__Container",
  componentId: "sc-13qinla-0"
})(["position:relative;display:inline-flex;justify-content:center;align-items:center;flex-wrap:nowrap;max-width:100%;width:", ";padding:0.75rem 1.6rem;border-radius:", ";font-size:", ";line-height:1.57;color:", ";cursor:pointer;outline:none;transition:background 200ms ease,box-shadow 200ms ease;", ";", ";", ""], function (_ref) {
  var fluid = _ref.fluid;
  return fluid ? '100%' : 'auto';
}, function (_ref2) {
  var dimensions = _ref2.theme.dimensions;
  return dimensions.radius;
}, function (_ref3) {
  var fonts = _ref3.theme.fonts;
  return fonts.size.medium;
}, function (_ref4) {
  var palette = _ref4.theme.palette;
  return palette.white;
}, function (_ref5) {
  var theme = _ref5.theme,
      appearance = _ref5.appearance;
  return getAppearance(theme, appearance);
}, function (_ref6) {
  var theme = _ref6.theme,
      size = _ref6.size,
      icon = _ref6.icon;
  return getSize(theme, size, icon);
}, function (_ref7) {
  var disabled = _ref7.disabled;
  return disabled && css(["cursor:not-allowed;opacity:0.4;"]);
});
/* Icon Container
 * An icon can be set to the left or to the right.
 * We change the flex order position and add a margin
 * according to the given props [left or right].
 */

export var ContainerIcon = styled.span.withConfig({
  displayName: "elements__ContainerIcon",
  componentId: "sc-13qinla-1"
})(["display:flex;order:", ";margin-right:", ";margin-left:", ";"], function (_ref8) {
  var right = _ref8.right;
  return right ? 1 : 0;
}, function (_ref9) {
  var left = _ref9.left;
  return left ? '1rem' : 0;
}, function (_ref10) {
  var right = _ref10.right;
  return right ? '1rem' : 0;
});